<template>
  <div id="app">
    <el-aside width="132px" class="sideBar">
      <SideBar></SideBar>
    </el-aside>
    <el-container>
      <el-header>
        <Nav></Nav>
      </el-header>
      <el-container>
        <el-main>
          <router-view />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import Nav from './components/Global/Nav.vue'
import SideBar from './components/Global/SideBar.vue'
export default {
  name: 'App',
  components: {
    Nav, SideBar
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app {
  display: flex;
}

.sideBar {
  height: 100vh;
}

.el-header {
  padding: 0;
  border-bottom: solid 1px #E6E6E6;
}

.red {
  color: #F00;
}

.blue {
  color: #409EFF;
}

.orange {
  color: #ff9c40;
}

.green {
  color: #0F0;
}

.gray,
.grey {
  color: #AAA;
}

.pagenation {
  width: 100%;
  display: flex;
  justify-content: right;
}

.alc-side-menu .el-badge__content.is-fixed {
  top: 12px !important;
  right: 5px;
}

.elink-icon i {
  font-size: 20px !important;
  margin: 0 5px;
}

.text-extra-small {
  font-size: 12px !important;
}

.text-small {
  font-size: 13px !important;
}

.text-base {
  font-size: 14px !important;
}

.text-medium {
  font-size: 16px !important;
}

.text-large {
  font-size: 18px !important;
}

.text-extra-large {
  font-size: 20px !important;
}

.breadcrumb {
  margin-bottom: 20px;
}

.page-header {
  display: flex;
  margin-bottom: 20px;
}

.website-detail-box {
  width: 100%;
  height: 72vh;
  box-sizing: border-box;
  padding: 10px 0;
  overflow: auto;
  word-wrap: break-word;
}

.website-detail-box-medium {
  width: 100%;
  height: 67.5vh;
  box-sizing: border-box;
  padding: 10px 0;
  overflow: auto;
  word-wrap: break-word;
}

.action-icon {
  margin-left: 10px;
}

.action-icon:hover {
  cursor: pointer;
  color: #409EFF;
}

.tiny-pop {
  min-width: 0 !important;
}

.page-desc {
  font-size: 12px;
  color: #5e6d82;
  line-height: 1.6;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue